module.exports = __webpack_public_path__ + "static/media/Graphic12.ba6c38db.png";